/**
 * AdminSpace — entry point for the admin role space.
 * Hosts AppShell with admin lateral navigation.
 * Feature pages (verification queue) land here in Part 4.
 */

import { Routes, Route, Navigate } from 'react-router-dom';
import AppShell from '../../components/layout/AppShell';
import VerificationQueuePage from './VerificationQueuePage';
import AdminTutorsPlaceholder from './AdminTutorsPlaceholder';

const AdminSpace = () => {
  return (
    <AppShell role="admin">
      <Routes>
        <Route index element={<Navigate to="verifications" replace />} />
        <Route path="verifications" element={<VerificationQueuePage />} />
        <Route path="repetiteurs" element={<AdminTutorsPlaceholder />} />
      </Routes>
    </AppShell>
  );
};

export default AdminSpace;
